// CEP validation (Brazilian postal code)
export const CEP_REGEX = /^\d{5}-?\d{3}$/;

export const validateCEP = (cep: string): boolean => {
  const cleanCEP = cep.replace(/\D/g, "");
  return cleanCEP.length === 8 && CEP_REGEX.test(cep);
};

export const formatCEP = (cep: string): string => {
  const cleanCEP = cep.replace(/\D/g, "");
  if (cleanCEP.length <= 5) return cleanCEP;
  return `${cleanCEP.slice(0, 5)}-${cleanCEP.slice(5, 8)}`;
};

export const formatStringToCurrency = (value: string): string => {
  const stringToFloat = parseFloat(value);
  if (isNaN(stringToFloat)) return "0,00";
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(stringToFloat);
};

// Currency formatting for pt-BR
export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);
};

// Property code validation (uppercase alphanumeric)
export const PROPERTY_CODE_REGEX = /^[A-Z0-9]{3,10}$/;

export const validatePropertyCode = (code: string): boolean => {
  return PROPERTY_CODE_REGEX.test(code.toUpperCase());
};

export const formatPropertyCode = (code: string): string => {
  return code.toUpperCase().replace(/[^A-Z0-9]/g, "");
};

export const validateCPF = (cpf: string): boolean => {
  // Remove non-digit characters
  const cleanCPF = cpf.replace(/\D/g, "");

  // Check if CPF has 11 digits
  if (cleanCPF.length !== 11) return false;

  // Check for known invalid CPFs
  if (/^(\d)\1+$/.test(cleanCPF)) return false;

  // Validate check digits
  let sum = 0;
  let remainder;

  // First check digit
  for (let i = 1; i <= 9; i++) {
    sum += parseInt(cleanCPF.substring(i - 1, i)) * (11 - i);
  }
  remainder = (sum * 10) % 11;
  if (remainder === 10) remainder = 0;
  if (remainder !== parseInt(cleanCPF.substring(9, 10))) return false;

  // Second check digit
  sum = 0;
  for (let i = 1; i <= 10; i++) {
    sum += parseInt(cleanCPF.substring(i - 1, i)) * (12 - i);
  }
  remainder = (sum * 10) % 11;
  if (remainder === 10) remainder = 0;
  if (remainder !== parseInt(cleanCPF.substring(10, 11))) return false;

  return true;
};
